import React from 'react';

export const Spinner = () => {
    return (
        <span className='bs-spinner' aria-hidden>
            <span className='bs-spinner__tick' />
            <span className='bs-spinner__tick' />
            <span className='bs-spinner__tick' />
            <span className='bs-spinner__tick' />
            <span className='bs-spinner__tick' />
            <span className='bs-spinner__tick' />
            <span className='bs-spinner__tick' />
            <span className='bs-spinner__tick' />
        </span>
    );
};
